import { PatientDetailUtils } from '../../../utils/PatientDetail.utils';
import { PatientDetailCard } from './PatientDetailCard';
import { graphql, getFragmentData } from '@orthly/graphql-inline-react';
import type { FragmentType } from '@orthly/graphql-inline-react';
import { Text } from '@orthly/ui-primitives';
import React from 'react';

const PatientDetailPatientCardPatient_Fragment = graphql(`
    fragment PatientDetailPatientCardPatient_Fragment on PatientDTO {
        first_name
        last_name
        birthday
        gender
    }
`);

interface PatientDetailPatientCardProps {
    patientFragment: FragmentType<typeof PatientDetailPatientCardPatient_Fragment>;
}

export const PatientDetailPatientCard: React.VFC<PatientDetailPatientCardProps> = props => {
    const patient = getFragmentData(PatientDetailPatientCardPatient_Fragment, props.patientFragment);

    const { name, birthday, age, gender } = PatientDetailUtils.getPatientDetailConfig(patient);

    return (
        <PatientDetailCard gridArea={'patient'} title={'Patient'}>
            <Text variant={'h4'}>{name}</Text>
            <Text component={'span'} variant={'body2'}>
                {birthday}{' '}
                <Text component={'span'} variant={'body2'} color={'DARK_GRAY'}>
                    ({age}), {gender}
                </Text>
            </Text>
        </PatientDetailCard>
    );
};
